const generateReferenceIdCustomFormat = () => {
  const now = new Date();

  // YYYYMMDD
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");

  // HHMMSS
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");
  const milliseconds = String(now.getMilliseconds()).padStart(3, "0");
  const randomSuffix = Math.random().toString(36).substring(2, 6).toUpperCase();

  return `REF-${year}${month}${day}-${hours}${minutes}${seconds}${milliseconds}-${randomSuffix}`;
};

export default generateReferenceIdCustomFormat;
